import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PricingService {
  constructor(private http: HttpClient) {}

  private pricingService = environment.integrationService + '/v1';

  //  Plans
  createSubscriptionPlan(payload: any): Observable<any> {
    return this.http
      .post<any>(this.pricingService + '/subscription-plan', payload, {
        headers: {
          'x-gateway': 'STRIPE'
        }
      })
      .pipe(catchError((err) => throwError(err)));
  }

  getAllSubscriptionPlan(payload: any): Observable<any> {
    return this.http
      .post<any>(this.pricingService + `/subscription-plan/all`, payload)
      .pipe(catchError((err) => throwError(() => err)));
  }

  updateSubscriptionPlan(payload: any, id: any): Observable<any> {
    return this.http
      .put<any>(this.pricingService + `/subscription-plan/${id}`, payload)
      .pipe(catchError((err) => throwError(err)));
  }

  deleteSubscriptionPlan(id: any): Observable<any> {
    return this.http
      .delete<any>(this.pricingService + `/subscription-plan/${id}`)
      .pipe(catchError((err) => throwError(err)));
  }

  getSubscribedCustomerById(id: any): Observable<any> {
    return this.http
      .get<any>(this.pricingService + `/subscription-plan/${id}`)
      .pipe(catchError((err) => throwError(err)));
  }

  // Subscriptions
  subscribePlans(payload: any): Observable<any> {
    return this.http
      .post<any>(this.pricingService + '/subscription', payload, {
        headers: {
          'x-gateway': 'STRIPE'
        }
      })
      .pipe(catchError((err) => throwError(err)));
  }
  getSubscribePlans(payload: any): Observable<any> {
    return this.http
      .get<any>(this.pricingService + '/subscription/all', {
        params: payload
      })
      .pipe(catchError((err) => throwError(err)));
  }
  updateSubscription(payload: any, id: any): Observable<any> {
    return this.http
      .put<any>(this.pricingService + `/subscription/${id}`, payload)
      .pipe(catchError((err) => throwError(err)));
  }
  getPlanBySubscriptionID(id: any): Observable<any> {
    return this.http
      .get<any>(this.pricingService + `/subscription/with-plan/${id}`)
      .pipe(catchError((err) => throwError(err)));
  }
  // Get transaction logs by Shop ID

  getTransactionLogsByShopId(payload: any): Observable<any> {
    return this.http
      .get<any>(this.pricingService + `/subscription-transaction/all`, {
        params: payload
      })
      .pipe(catchError((err) => throwError(err)));
  }
  getSubscriptionByStripID(payload: any): Observable<any> {
    return this.http
      .get<any>(this.pricingService + `/subscription/${payload}`)
      .pipe(catchError((err) => throwError(err)));
  }
}
